<ng-template #productUploadModal let-modal>
  <div *ngIf="isSuccess">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Batch Menu Upload</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click'); onCloseModal(false)"
              title="Close Modal"></button>
    </div>

    <div class="modal-body" [style.max-height.px]="modalHeight">
      <div class="d-flex">
        <div class="col-sm-9">
          <div class="file-upload-container">
            <label for="fileInput">FILE</label>
            <div class="file-input-wrapper">
              <input type="text"
                     [value]="fileName"
                     class="cursor-pointer"
                     readonly
                     (click)="fileInput.click()" />

              <button type="button" (click)="fileInput.click()" class="icon-button">
                <img src="../assets/images/file-upload-icon.svg" alt="Add Icon" class="add-icon" />
              </button>
            </div>
            <input type="file"
                   #fileInput
                   (change)="onFileSelected($event)"
                   class="d-none" />
            <span class="text-end last-prod">
              *last product number used: {{businessDetails.lastProductNumber}}
            </span>
          </div>
        </div>
        <div class="col-sm-3 csv-example-section" (click)="downloadCSVExample();">
          <img src="../assets/images/csv-file-icon.svg" alt="Add Icon" class="add-icon csv-example-icon" />
          <span class="csv-example ms-1">CSV EXAMPLE</span>
        </div>
      </div>

      <input type="file"
             multiple
             #imageInput
             accept="image/*"
             class="d-none"
             (change)="onImagesSelected($event);" />

      <div class="img-section" (click)="images.length == 0 ? imageInput.click() : false">
        <label for="IMAGES">IMAGES</label>
        <div class="image-section" [ngClass]="{'d-flex justify-content-center':images.length <= 0}" [style.min-height.px]="modalHeight - 200" [style.max-height.px]="modalHeight - 230">
          <div class="row">
            <div *ngIf="images.length <= 0" class="d-flex align-items-center text-muted">
              Please click here to upload your photos
            </div>
            <div class="col-sm-6" *ngFor="let img of images; let i = index">
              <div class="image-preview d-flex justify-content-between mt-2" *ngIf="img.preview">
                <div class="d-flex flex-shrink">
                  <img [src]="img.preview" class="rounded" />
                  <div class="fw-bold fs-5 ms-2">{{img.file?.name}}</div>
                </div>
                <button class="btn btn-primary remove-btn me-3" (click)="removeImage(i, $event)">Remove</button>
              </div>
            </div>
          </div>
          <div *ngIf="images.length > 0" class="image-preview">
            <label for="ADD IMAGES" class="cursor-pointer" (click)="imageInput.click()">ADD IMAGES</label>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn btn-primary upload-btn" (click)="uploadData()">Upload Menu Items And/or Images</button>
    </div>
  </div>
  <div *ngIf="!isSuccess && !isInvalidCategory">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Upload Error</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click'); onCloseModal()"
              title="Close Modal"></button>
    </div>

    <div class="modal-body body-padding" [style.height.px]="modalHeight">
      <div *ngIf="uploadDataResponse.csvUploadProgress == 2">
        <div class="fw-bold">Your CSV contains a few issues</div>
        <div class="card mt-1">
          <div class="card-body" [style.height.px]="csvErrorContentHeight">
            <div>
              <div *ngIf="uploadDataResponse.records.duplicateProductError != null">
                <div class="fw-bold">Duplicate Products</div>
                <div> {{uploadDataResponse.records.duplicateProductError}} </div>
              </div>
              <div class="mt-1" *ngIf="uploadDataResponse.records.productItemNumberMissingError != null">
                <div class="fw-bold">Missing Product Numbers</div>
                <div> {{uploadDataResponse.records.productItemNumberMissingError}} </div>
              </div>
              <div class="mt-1" *ngIf="uploadDataResponse.records.productPriceMissingError != null">
                <div class="fw-bold">Missing Products price</div>
                <div> {{uploadDataResponse.records.productPriceMissingError}} </div>
              </div>
              <div class="mt-1" *ngIf="uploadDataResponse.records.priceConversionError != null">
                <div class="fw-bold">Invalid Price</div>
                <div> {{uploadDataResponse.records.priceConversionError}} </div>
              </div>
              <div class="mt-1" *ngIf="uploadDataResponse.records.invalidCategoriesError != null">
                <div class="fw-bold">Invalid Categories</div>
                <div> {{uploadDataResponse.records.invalidCategoriesError}} </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-3" *ngIf="uploadDataResponse.imageUploadProgress == 2">
        <div class="fw-bold">Your Image files contains a few issues</div>
        <div class="card mt-1">
          <div class="card-body" [style.height.px]="imageErrorContentHeight">
            <div>
              <div *ngIf="uploadDataResponse.imageResponse.duplicateImages != null">
                <div class="fw-bold">Duplicate Images</div>
                <div> {{uploadDataResponse.imageResponse.duplicateImages}} </div>
              </div>
              <div *ngIf="uploadDataResponse.imageResponse.productNotFoundForImages != null" class="mt-1">
                <div class="fw-bold">Product Not Found For Images</div>
                <div> {{uploadDataResponse.imageResponse.productNotFoundForImages}} </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer content-end">
      <a class="btn btn-link last-prod text-decoration-none" *ngIf="uploadDataResponse.records.invalidCategoriesError != null" (click)="isInvalidCategory = true;">Map Custom Categories</a>
      <a class="btn btn-link last-prod" (click)="failedCSVList()" *ngIf="uploadDataResponse.csvUploadProgress == 2">
        <img src="../assets/images/csv-file-icon.svg" alt="Add Icon" class="add-icon csv-example-icon" />
        <span class="ms-2">Download Error Files</span>
      </a>
      <button class="btn btn-primary" (click)="reUpload()">Retry Upload</button>
    </div>
  </div>

  <div *ngIf="!isSuccess && isInvalidCategory && !isConfirmCategory">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Custom Categories</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click'); onCloseModal()"
              title="Close Modal"></button>
    </div>
    <div class="modal-body body-padding text-muted" [style.max-height.px]="modalHeight">
      <p class="fs-17">HUNGERY is build to keep it simple for users to understand our listings, so we are limiting our categories to only 5.</p>
      <p class="mt-4 fs-17">
        But if you would like to keep your category data for future POS use, please map them to our categories so it will be
        displayed properly:
      </p>

      <div class="mt-4">
        <div class="fw-bold">CATEGORY MAPPING</div>
        <div class="card mt-2">
          <div class="card-body auto-scroll-vertical">
            <div>
              <div class="row g-2">
                <div class="col-12 col-md-6 text-muted fw-bold">
                  Your Category
                </div>
                <div class="col-12 col-md-6 text-muted fw-bold">Mapped Category</div>
                <div *ngFor="let category of categoryMapping" class="row g-2">
                  <div class="col-12 col-md-6">
                    <input type="text" class="form-control" value={{category.yourCategory}} readonly />
                  </div>
                  <div class="col-12 col-md-6">
                    <app-select [options]="types" [selectClass]="'ng-form-select primary-select'"
                                selectPlaceholder="Select Type" [(selectedValue)]="category.mappedCategory"></app-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer content-end">
      <a class="btn btn-link last-prod text-decoration-none" (click)="reUpload()">Retry Upload Instead</a>
      <button class="btn btn-primary" (click)="isConfirmCategory=!isConfirmCategory">Confirm</button>
    </div>
  </div>

  <div *ngIf="!isSuccess && isInvalidCategory && isConfirmCategory">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Confirm Category Mapping</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click'); onCloseModal()"
              title="Close Modal"></button>
    </div>
    <div class="modal-body body-padding text-muted" [style.max-height.px]="modalHeight">
      <p class="fs-17">
        Please make sure that there are no spelling errors and your capitalizations are in place. Press
        CONFIRM again to submit Mapped Categories
      </p>

      <div class="mt-3">
        <div class="fw-bold">CONFIRM MAPPING</div>
        <div class="card mt-2">
          <div class="card-body auto-scroll-vertical">
            <div>
              <table class="table table-borderless align-middle mb-0">
                <thead>
                  <tr class="text-muted fw-bold">
                    <th width="20%" class="text-muted">Your Category</th>
                    <th width="5%"></th>
                    <th class="text-muted">Mapped Category</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let category of categoryMapping">
                    <td width="20%" class="text-purple fw-semibold">{{category.yourCategory}}</td>
                    <td width="5%" class="text-center text-muted">--></td>
                    <td class="text-purple fw-semibold">{{category.mappedCategory.title}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer content-end">
      <a class="btn btn-link last-prod text-decoration-none" (click)="isConfirmCategory=!isConfirmCategory">Fix Mapping Mistake</a>
      <button class="btn btn-primary" (click)="confirmMapping()">Confirm</button>
    </div>
  </div>
</ng-template>
